import { getLocalStorageData, saveLocalStorageData } from '@/utils/local-storage';

type TCaseUnreadItem = {
  caseId: string;
  messageOrder: number;
};
type TCaseUnread = TCaseUnreadItem[];

const CASE_UNREAD_KEY = 'case_unread';

/** In-memory cache to avoid repeated localStorage reads in the same tab (prod perf). */
let cache: TCaseUnread | null = null;

function readFromStorage(): TCaseUnread {
  const data = getLocalStorageData(CASE_UNREAD_KEY);
  return Array.isArray(data) ? data : [];
}

export const getCaseUnread = (): TCaseUnread => {
  if (cache !== null) return cache;
  cache = readFromStorage();
  return cache;
};

export const getCaseUnreadByCaseId = (caseId: string): TCaseUnreadItem | undefined => {
  return getCaseUnread().find((item) => item.caseId === caseId);
};

export const getCaseUnreadAndCount = (caseId: string): number => {
  const caseUnread = getCaseUnreadByCaseId(caseId);
  return caseUnread !== undefined && caseUnread.messageOrder > 0 ? caseUnread.messageOrder : 0;
};

export const saveCaseUnread = (caseUnread: TCaseUnread) => {
  saveLocalStorageData(CASE_UNREAD_KEY, caseUnread);
  cache = caseUnread;
};

export const deleteCaseUnread = (caseId: string) => {
  const filtered = getCaseUnread().filter((item) => item.caseId !== caseId);
  saveCaseUnread(filtered);
};

export const updateCaseUnread = (caseId: string, messageOrder: number) => {
  const updated = getCaseUnread().map((item) => (item.caseId === caseId ? { ...item, messageOrder } : item));
  saveCaseUnread(updated);
};

export const updateOrSaveCaseUnread = (caseId: string, messageOrder: number) => {
  const caseUnread = getCaseUnread();
  const index = caseUnread.findIndex((item) => item.caseId === caseId);
  if (index >= 0) {
    const updated = [...caseUnread];
    updated[index] = { ...updated[index], messageOrder };
    saveCaseUnread(updated);
  } else {
    saveCaseUnread([...caseUnread, { caseId, messageOrder }]);
  }
};
